import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProductDetail from '../views/ProductDetail.vue'
import ConfirmSnag from '../views/ConfirmSnag.vue'
import OrderDetail from '../views/OrderDetail.vue'
import Categories from '../views/Categories.vue'
import Favorites from '../views/Favorites.vue'
import Snags from '../views/Snags.vue'
import Wallet from '../views/Wallet.vue'
import Account from '../views/Account.vue'
import FAQ from '../views/FAQ.vue'
import Contact from '../views/Contact.vue'
import About from '../views/About.vue'
import Policy from '../views/Policy.vue'
import Service from '../views/Service.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home
  },
  {
    path: '/productDetail/:id',
    name: '产品详情',
    component: ProductDetail
  },
  {
    path: '/confirm-snag/:id',
    name: '确认抢购',
    component: ConfirmSnag
  },
  {
    path: '/order-detail/:id',
    name: '订单详情',
    component: OrderDetail
  },
  {
    path: '/categories',
    name: '分类',
    component: Categories
  },
  {
    path: '/favorites',
    name: '收藏',
    component: Favorites
  },
  {
    path: '/snags',
    name: 'Snags',
    component: Snags
  },
  {
    path: '/wallet',
    name: '钱包',
    component: Wallet
  },
  {
    path: '/account',
    name: '账户',
    component: Account
  },
  {
    path: '/faq',
    name: '常见问题',
    component: FAQ
  },
  {
    path: '/contact',
    name: '联系',
    component: Contact
  },
  {
    path: '/about',
    name: '关于',
    component: About
  },
  {
    path: '/policy',
    name: '隐私',
    component: Policy
  },
  {
    path: '/service',
    name: '用户',
    component: Service
  }
]
//history hash
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 解决重复导航到同一路由的错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

export default router
